let Values = {
  OK       : 'OK',
  REPAIRING: 'REPAIRING',
  STOLEN   : 'STOLEN',
  LOST     : 'LOST',
  DESTROYED: 'DESTROYED'
};

export default Object.seal({
  ...Values,

  /* All values */
  values: Object.keys(Values),

  /* Get name for value. */
  name: (value) => {
    switch (value) {
      case Values.OK:
        return 'OK';
      case Values.REPAIRING:
        return 'En réparation';
      case Values.STOLEN:
        return 'Volé';
      case Values.LOST:
        return 'Perdu';
      case Values.DESTROYED:
        return 'Détruit';
      default:
        console.error("Reached default case")
        break;
    }
  },

  /* Get color for value. */
  color: (value) => {
    switch (value) {
      case Values.OK:
        return 'green';
      case Values.REPAIRING:
        return 'yellow';
      case Values.STOLEN:
      case Values.LOST:
      case Values.DESTROYED:
        return 'red';
      default:
        console.error("Reached default case")
        break;
    }
  },

  weight: (value) => {
    switch (value) {
      case Values.OK:
        return 0;
      case Values.REPAIRING:
        return 1;
      case Values.STOLEN:
        return 2;
      case Values.LOST:
        return 3;
      case Values.DESTROYED:
        return 4;
      default:
        console.error("Reached default case")
        break;
    }
  }
});
